/* eslint-disable func-names */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable import/no-cycle */
import { Component } from 'preact';
import { PropTypes } from 'preact-compat';
import { route } from 'preact-router';
import { bindActionCreators } from 'redux';
import { connect } from 'preact-redux';
import style from './style.scss';

import Chat from '../chat';
import Call from '../call';
import { consts } from '../../../utils/consts';
import {
  closeComModal,
  pickUp,
} from '../../../actions/chat';

import { routes } from '../../app';

class Communication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      callSec: 0,
    };
  }

  componentDidMount() {
    if (!this.anyUnreadNotifications()) {
      const { type, comModal, closeComModal: closeCModal } = this.props;
      if (type !== consts.CALL && comModal.isChatOpened) {
        closeCModal(consts.CHAT);
      }
    }
  }

  componentDidUpdate() {
    if (!this.anyUnreadNotifications()) {
      const { type, comModal, closeComModal: closeCModal } = this.props;
      if (type !== consts.CALL && comModal.isChatOpened) {
        closeCModal(consts.CHAT);
      }
    }
  }

  componentWillUnmount() {
    if (this.autoRejectTimeout) this.undoAutoReject();
    if (this.callSecondsInterval) this.undoCallSecInterval();
  }

  anyUnreadNotifications = () => this.props.badges.totalMissedCall || this.props.badges.totalMissedMessage;

  undoCallSecInterval = () => {
    clearInterval(this.callSecondsInterval);
    this.callSecondsInterval = null;
  }

  onClose = () => {
    const { type, comModal, closeComModal: closeCModal } = this.props;
    if (type === consts.CALL) {
      if (this.autoRejectTimeout) {
        this.undoAutoReject();
        this.rejectCall();
      }
      this.rejectCall();
    } else if (comModal.isChatOpened) {
      closeCModal(consts.CHAT);
    } else {
      closeCModal();
    }
  }

  // new func
  rejectCall = (isBusy = false) => {
    const { connection: { rejectCall: rejCall } } = this.props;
    rejCall(isBusy);
    // this.props.closeComModal();
  }

  // call start (приём?)
  // new func
  requestGranted = () => {
    const { comModal, pickUp: picUpFunc, connection } = this.props;
    // eslint-disable-next-line no-console
    console.warn('requestGranted');
    // route(routes.CLIENT_FOR_COMP + this.props.comModal.person.id + '#call');

    connection.rescanMediaDevices(true).then(() => {
      if (comModal.callInfo.fcid) {
        route(`${routes.FEATURED_SERVICE_FOR_COMP}/${comModal.callInfo.fcid}`);
      } else {
        route(`${routes.USER_FOR_COMP}${comModal.person.id}#call`);
      }
      picUpFunc();
    }).catch((err) => connection.failCall(connection.tryGetMediaCaptureErrorReason(err)));
  };

  render({ badges, users }) {
    const { chooseChatPerson, comModal, isConnected, locale } = this.props;
    const { type: modalType, isOutcoming, isPickUp, isChatOpened } = comModal;
    const { callSec } = this.state;
    return (((modalType && !isOutcoming && !isPickUp) || (isChatOpened && this.anyUnreadNotifications())) && (
      <div className={style.callAreaBackground}>
        {isChatOpened && (
        <div className={style.callArea}>
          <div className={style.closeBtn} onClick={this.onClose} />
          <Chat
            users={users}
            communicateModal={comModal}
            chooseChatPerson={chooseChatPerson}
            isConnected={isConnected}
            badges={badges}
            locale={locale}
          />
        </div>
        )}
        {(modalType === consts.CALL && !isOutcoming && !isPickUp) && (
          <div className={style.callArea}>
            <Call
              communicateModal={comModal}
              seconds={callSec}
              closeModal={this.onClose}
              pickUp={this.requestGranted}
              rejectCall={this.rejectCall}
              isConnected={isConnected}
              locale={locale}
            />
          </div>
        )}
      </div>
    ));
  }
}

Communication.propTypes = {
  closeComModal: PropTypes.func.isRequired,
  pickUp: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  isConnected: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  comModal: PropTypes.shape({
    type: PropTypes.string,
    isBusy: PropTypes.bool,
    isOutcoming: PropTypes.bool,
    isIncoming: PropTypes.bool,
    isCalling: PropTypes.bool,
    isSpeaking: PropTypes.bool,
    chats: {},
    isConnected: PropTypes.bool,
    userVideoStream: PropTypes.bool,
    isPickUp: PropTypes.bool,
    callInfo: PropTypes.shape({
      fcid: PropTypes.number,
    }),
    person: PropTypes.shape({
      id: PropTypes.number,
    }),
    isReconnect: PropTypes.bool,
    isChatOpened: PropTypes.bool,
  }).isRequired,
  chooseChatPerson: PropTypes.func.isRequired,
  connection: PropTypes.shape({
    rejectCall: PropTypes.func,
    failCall: PropTypes.func,
    tryGetMediaCaptureErrorReason: PropTypes.func,
    rescanMediaDevices: PropTypes.func,
  }).isRequired,
  badges: PropTypes.shape({
    totalMissedCall: PropTypes.number.isRequired,
    totalMissedMessage: PropTypes.number.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  user: state.loggedInUser,
  comModal: state.communicateModal,
  locale: state.locale.locale,
  badges: state.badges.data || {},
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  closeComModal,
  pickUp,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Communication);



// WEBPACK FOOTER //
// ./components/communication/communication-component/index.js